// extracted by mini-css-extract-plugin
export default {"time":"Stopwatch_time__iU8kb"};